import React from "react";
import { IconProps } from "../../types/component";
import useChakraColor from "../../hooks/useChakraColor";

export const Mail: React.FC<IconProps> = ({ size = 18, color = "#0C727E" }) => {
  const iconColor = useChakraColor(color);
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.4163 7.90083V15.0417C17.4163 15.9125 16.7038 16.625 15.833 16.625H3.16634C2.29551 16.625 1.58301 15.9125 1.58301 15.0417L1.59092 5.54167C1.59092 4.67083 2.29551 3.95833 3.16634 3.95833H11.1622C11.1147 4.21167 11.083 4.48083 11.083 4.75C11.083 5.01917 11.1147 5.28833 11.1622 5.54167H3.16634L9.49967 9.5L12.4051 7.68708C12.7772 8.0275 13.2126 8.28875 13.6955 8.46292L9.49967 11.0833L3.16634 7.125V15.0417H15.833V8.62917C16.4188 8.51042 16.9572 8.24917 17.4163 7.90083ZM12.6663 4.75C12.6663 6.06417 13.7272 7.125 15.0413 7.125C16.3555 7.125 17.4163 6.06417 17.4163 4.75C17.4163 3.43583 16.3555 2.375 15.0413 2.375C13.7272 2.375 12.6663 3.43583 12.6663 4.75Z"
        fill={iconColor}
      />
    </svg>
  );
};

export const Dot: React.FC<IconProps> = ({ size = 12, color = "#E67D4F" }) => {
  const iconColor = useChakraColor(color);
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="6" cy="6" r="6" fill={iconColor} />
    </svg>
  );
};

export const ExclamationMark: React.FC<IconProps> = ({
  size = 12,
  color = "indicate.brightRed",
}) => {
  const iconColor = useChakraColor(color);
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 4 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.7002 13.1262C3.7002 12.8801 3.65234 12.6364 3.55937 12.4091C3.4664 12.1817 3.33013 11.9752 3.15834 11.8012C2.98655 11.6272 2.78261 11.4891 2.55816 11.395C2.33371 11.3008 2.09314 11.2523 1.8502 11.2523C1.60725 11.2523 1.36668 11.3008 1.14223 11.395C0.917778 11.4891 0.713836 11.6272 0.542048 11.8012C0.37026 11.9752 0.233989 12.1817 0.141018 12.4091C0.0480468 12.6364 0.000195265 12.8801 0.000195265 13.1262C0.000195265 13.6231 0.195106 14.0998 0.542048 14.4512C0.88899 14.8026 1.35954 15 1.8502 15C2.34085 15 2.8114 14.8026 3.15834 14.4512C3.50528 14.0998 3.7002 13.6231 3.7002 13.1262ZM3.5189 1.87383C3.54353 1.63743 3.51882 1.39842 3.44637 1.17232C3.37393 0.946216 3.25536 0.738066 3.09836 0.561375C2.94136 0.384684 2.74943 0.243399 2.53504 0.146688C2.32065 0.0499767 2.08859 0 1.8539 0C1.6192 0 1.38714 0.0499767 1.17275 0.146688C0.958356 0.243399 0.766435 0.384684 0.609435 0.561375C0.452436 0.738066 0.333864 0.946216 0.261415 1.17232C0.188967 1.39842 0.16426 1.63743 0.188896 1.87383L0.836395 8.44535C0.862702 8.70012 0.981245 8.93599 1.16915 9.10745C1.35705 9.2789 1.60099 9.37378 1.8539 9.37378C2.1068 9.37378 2.35074 9.2789 2.53864 9.10745C2.72654 8.93599 2.84509 8.70012 2.8714 8.44535L3.5189 1.87383Z"
        fill={iconColor}
      />
    </svg>
  );
};
